import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Printer, ArrowRight } from "lucide-react";
import api from "../lib/api";

// "588 ducks printed so far" — library ducks + Duckify orders; nudges new visitors toward "Print this for me".
export const PrintedCounterBadge = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/public/stats").then((r) => alive && setStats(r.data)).catch(() => alive && setStats(null));
    return () => {
      alive = false;
    };
  }, []);

  if (!stats?.printed) return null;
  const inner = (
    <>
      <Printer className="h-4 w-4 text-accent shrink-0" />
      <span data-testid="printed-counter-count" className="font-heading font-bold">{stats.printed.toLocaleString()}</span>
      <span className="text-muted-foreground">ducks printed so far by Zero Ducks Given</span>
      {stats.example_id && (
        <span className="hidden sm:inline-flex items-center gap-1 text-accent font-semibold">
          · no printer? we print yours <ArrowRight className="h-3.5 w-3.5" />
        </span>
      )}
    </>
  );
  const cls = "mt-4 inline-flex flex-wrap items-center gap-2 rounded-full border border-border bg-card/70 px-4 py-2 text-sm animate-pop";
  return stats.example_id ? (
    <Link data-testid="printed-counter-badge" to={`/s/${stats.example_id}`} className={`${cls} hover:border-accent/60 transition-colors`}>{inner}</Link>
  ) : (
    <span data-testid="printed-counter-badge" className={cls}>{inner}</span>
  );
};
